<template lang="pug">
  .auth--confirm
    img.auth__logo(:alt="appName" :src="logoPath")

    form.auth__form(
      v-if="!success && !fails"
      @submit.prevent="loginUser")

      //- Email input
      input(
        type="email"
        name="email"
        v-model="email"
        v-validate="'required|email'"
        :data-vv-as="$t('email')"
        :class="{'error': errors.has('email') }"
        :placeholder="$t('email')")

      //- Password input
      .auth__password
        input(
          :type="passwordField"
          name="password"
          v-model="password"
          v-validate="'required|max:64|min:8'"
          :data-vv-as="$t('password')"
          :class="{'error': errors.has('password') }"
          :placeholder="$t('password')")
        .togglePassword(@click="togglePassword")
          van-icon(:name="passwordIcon")

      //- Form errors
      .margin-halve-top
        .auth__error(v-show="errors.has('name')") {{ errors.first('name') }}
        .auth__error(v-show="errors.has('lastName')") {{ errors.first('lastName') }}
        .auth__error(v-show="errors.has('email')") {{ errors.first('email') }}
        .auth__error(v-show="errors.has('password')") {{ errors.first('password') }}
        .auth__error(v-show="failsNotExist") {{ $t('errors.userNotExist.message')}}

      //- Submit button
      van-button(
        size="large"
        type="primary"
        native-type="submit") {{ $t('send') }}

    //- Fails send email confirm
    .text--center(v-if="fails")
      van-icon(name="error")
      h1 {{ $t('errors.general.title')}}
      p {{ $t('errors.general.message')}}
</template>

<script>
import i18n from "@/i18n";
import axios from "axios";
import { PROYECT } from "@/constant";

export default {
  data() {
    return {
      appName: PROYECT.NAME,
      logoPath: `/${PROYECT.LOGO}.svg`,
      email: "",
      password: "",
      success: false,
      fails: false,
      failsNotExist: false,
      passwordField: "password",
      passwordIcon: "hide"
    };
  },
  methods: {
    /*
     * Toggle Password input
     */
    togglePassword() {
      this.passwordField = this.passwordField === "password" ? "text" : "password";
      this.passwordIcon = this.passwordField === "password" ? "hide" : "show";
    },

    /*
     * Login user
     */
    loginUser() {
      this.failsNotExist = false;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$toast.loading({
            duration: 0,
            mask: true,
            message: i18n.t("loading")
          });

          const data = {
            email: this.email,
            password: this.password
          };

          axios({ url: `auth/login/${PROYECT.HOST}`, data, method: "POST" })
            .then(user => {
              this.$toast.clear();
              this.success = true;
              this.$emit("logged", user.data);
            })
            .catch(error => {
              this.$toast.clear();

              if (
                error.response &&
                error.response.data &&
                error.response.data._id === "userNotExist"
              ) {
                this.failsNotExist = true;
              } else {
                this.fails = true;
              }
            });
        }
      });
    }
  }
};
</script>
